"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePaymentVerification = exports.PaymentUpdatedContract = exports.PaymentCreatedContract = exports.PaymentEventDataContract = exports.paymentSourcesCheck = exports.PaymentSources = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const events_1 = require("@getgreenline/events");
var PaymentSources;
(function (PaymentSources) {
    PaymentSources[PaymentSources["IN_STORE"] = 0] = "IN_STORE";
    PaymentSources[PaymentSources["ONLINE"] = 1] = "ONLINE";
})(PaymentSources || (exports.PaymentSources = PaymentSources = {}));
// array that contains values of PaymentSources enum to be used in IsIn() validation
exports.paymentSourcesCheck = [PaymentSources.IN_STORE, PaymentSources.ONLINE];
class PaymentEventDataContract {
}
exports.PaymentEventDataContract = PaymentEventDataContract;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "refundPaymentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "deviceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "deviceName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "customId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "employeeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "employeeName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "customerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "customerName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "completeDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)()
], PaymentEventDataContract.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "subTotal", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "tax", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "pennyAdjustment", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsIn)(exports.paymentSourcesCheck)
], PaymentEventDataContract.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "tendered", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "paymentLines", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "taxPaymentLines", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "transactions", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "shiftId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "wooCommerceOrderId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "inventorySubtracted", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "offlinePaymentId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "paymentQueueId", void 0);
__decorate([
    (0, class_transformer_1.Expose)()
], PaymentEventDataContract.prototype, "paymentVerification", void 0);
class PaymentCreatedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.payment = events_1.GreenlineEvent.create(PaymentEventDataContract, params.payment);
    }
}
exports.PaymentCreatedContract = PaymentCreatedContract;
class PaymentUpdatedContract extends events_1.EventContract {
    constructor(params) {
        super(params);
        this.payment = events_1.GreenlineEvent.create(PaymentEventDataContract, params.payment);
    }
}
exports.PaymentUpdatedContract = PaymentUpdatedContract;
class CreatePaymentVerification {
}
exports.CreatePaymentVerification = CreatePaymentVerification;
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
], CreatePaymentVerification.prototype, "ageVerifiedAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], CreatePaymentVerification.prototype, "isScanned", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)()
], CreatePaymentVerification.prototype, "isExpired", void 0);
//# sourceMappingURL=payments.js.map